<template lang="html">
  <OwnershipsManagement type="Symbium Plancheck" currentMenu="Account" subMenu="Plancheck Subscriptions" />
</template>

<script>
import OwnershipsManagement from './OwnershipsManagement.vue'

export default {
  components: { OwnershipsManagement }
}
</script>

<style lang="css" scoped>
</style>
